import React, { useState, useEffect, useRef } from "react";
import { CircularProgress, Grid } from "@mui/material";
import axios from "axios";
import VerifyOTP from "../verify-otp/verify-otp";
import "../../styles/request-otp/request-otp.scss";
import ReactFlagsSelect from "react-flags-select";

const countryCodes = {
  IN: "+91",
};

const countries = Object.keys(countryCodes);

const OTPButton = ({ cartValue }) => {
  const [selectedCountry, setSelectedCountry] = useState("IN");
  const [loading, setLoading] = useState(false);
  const [isValidMobile, setIsValidMobile] = useState(false);
  const [showError, setShowError] = useState(false);
  const [requestOtpResponse, setRequestOtpResponse] = useState({ stateCode: "", message: "" });
  const [timer, setTimer] = useState(0);
  const [loyaltyData, setLoyaltyData] = useState({ mobileNumber: "", countryCode: countryCodes["IN"], storeUrl: "", cartValue: cartValue });
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus({ preventScroll: true });
  }, []);

  const handleSelectCountry = (country) => {
    setSelectedCountry(country);

    setLoyaltyData((preData) => ({ ...preData, countryCode: countryCodes[country] }));
  };

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleChangeMobileNumber = (event) => {
    const value = event.target.value.replace(/\D/, "");
    const regex = /^[0-9]{10}$/;
    const isValid = regex.test(value);
    setIsValidMobile(isValid);

    setLoyaltyData((preData) => ({ ...preData, mobileNumber: value }));
  };

  const handleSendOTP = async (event) => {
    event?.preventDefault();
    setLoading(true);

    setRequestOtpResponse((prevState) => ({
      ...prevState,
      message: "",
    }));

    const data = {
      mobile_number: loyaltyData.mobileNumber,
      country_code: loyaltyData.countryCode,
      store_url: loyaltyData.storeUrl,
    };

    const source = axios.CancelToken.source();

    try {
      const responsePromise = axios.post(`${process.env.REACT_APP_PRODUCTION_URL}/api/ewards/customer-get-loyalty-info`, data, { cancelToken: source.token });

      const timeoutPromise = new Promise((resolve, reject) => {
        setTimeout(() => {
          reject(new Error("Request timed out"));
          source.cancel("Request timed out");
        }, 20000);
      });

      const response = await Promise.race([responsePromise, timeoutPromise]);

      if (response) {
        localStorage.setItem("loyaltyData", JSON.stringify(loyaltyData));

        setLoading(false);
        setTimer(30);
        setRequestOtpResponse({
          stateCode: response?.data?.otpResponse.status_code,
          message: response?.data?.otpResponse.response.message,
        });
      } else {
        setRequestOtpResponse({
          stateCode: "",
          message: "Something went wrong!",
        });
      }
    } catch (error) {
      if (error.message === "Request timed out") {
        setRequestOtpResponse({
          stateCode: "",
          message: "Request timed out. Please try again later.",
        });
      } else {
        let errorMessage = "";
        if (error.response) {
          if (error.response.status === 500) {
            errorMessage = "Internal Server Error. Please try again later.";
          } else {
            errorMessage = error.response.data?.resultMessage?.en || "Request failed";
          }
        } else {
          errorMessage = "Network error. Please check your internet connection.";
        }
        setRequestOtpResponse({
          stateCode: error.response ? error?.response?.status : "",
          message: errorMessage,
        });
      }

      setLoading(false);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setLoyaltyData((preData) => ({ ...preData, storeUrl: searchParams.get("storeUrl") }));
  }, []);

  const handleEditRequestOtpForm = () => {
    setRequestOtpResponse({ stateCode: "", message: "" });
  };

  // useEffect(() => {
  //   const storedLoyaltyData = localStorage.getItem("loyaltyInfo");
  //   if (storedLoyaltyData) {
  //     setRequestOtpResponse({ stateCode: 200, message: "" });
  //   }
  // }, []);

  return (
    <div>
      <div style={{ display: requestOtpResponse.stateCode === 200 ? "none" : "block" }}>
        <h3 style={{ color: "#413C49", display: "inline-block" }}>Claim Your Loyalty Points</h3>

        <form className="otp-request-form" onSubmit={handleSendOTP}>
          <Grid container>
            <Grid item xs={12} sm={2} md={1.5} sx={{ mr: 1 }}>
              <ReactFlagsSelect className="country-code-dropdown" selected={selectedCountry} onSelect={handleSelectCountry} countries={countries} customLabels={countryCodes} defaultCountry="IN" />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <input
                autoComplete="off"
                type="text"
                style={{ fontFamily: "var(--font-family)" }}
                placeholder="Enter your mobile number"
                className={`custom-textfield mobile-field ${!isValidMobile && showError ? "error" : ""}`}
                value={loyaltyData.mobileNumber}
                onChange={handleChangeMobileNumber}
                onBlur={() => setShowError(!isValidMobile && loyaltyData.mobileNumber !== "")}
                maxLength={10}
                ref={inputRef}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={4}>
              <button style={{ cursor: isValidMobile ? "pointer" : "not-allowed" }} className="custom-button verify-button" type="submit" disabled={!isValidMobile}>
                Receive OTP
              </button>
            </Grid>
          </Grid>
        </form>
        <h3 className="mobile-text">
          <span style={{ color: "var(--primary-color)" }}>Note: </span>Please login before redeeming your loyalty points or coupons.
        </h3>

        <p className={requestOtpResponse.stateCode === 200 ? "success-msg" : "error-msg"}>{requestOtpResponse.message}</p>

        {requestOtpResponse.message === "Customer not found." && (
          <p>
            <a className="signup-button" href={`${loyaltyData.storeUrl}/my-account`} target="_blank" rel="noopener noreferrer">
              Signup
            </a>
          </p>
        )}
      </div>
      <div style={{ display: requestOtpResponse.stateCode === 200 ? "block" : "none" }}>
        <VerifyOTP timer={timer} handleEditRequestOtpForm={handleEditRequestOtpForm} handleSendOtp={handleSendOTP} loyaltyData={loyaltyData} />
      </div>
      {loading && <CircularProgress sx={{ color: "var(--primary-color)" }} />}
    </div>
  );
};

export default OTPButton;
